<template>
    <v-container class="visao-analitica mb-3 pt-1 px-0">
        <v-row v-if="exibirGraficos">
            <v-col cols="12" sm="12" md="12">
                <ChartPie
                :date="dataReferencia"
                :list="autorizacoes"
                :periodo="periodo"
                tipo="Autorizacao"
                :categorias="categoriasAutorizacao"
                :title="'SOLICITAÇÕES DE AUTORIZAÇÃO DO ' + title"
                :setFilter="(filterData)=>setFilter(filterData)"
                />
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <ChartPie
                :date="dataReferencia"
                :list="transacoes"
                :periodo="periodo"
                tipo="Transacao"
                :categorias="categoriasTransacao"
                :title="'TRANSAÇÕES DO ' + title"
                :setFilter="(filterData)=>setFilter(filterData)"
                />
            </v-col>
        </v-row>
        <v-row v-if="exibirTabelas">
          <v-col class="pa-0" cols="12" sm="12" md="12">
              <DashboardList
              :categorias="categoriasAutorizacao"
              :date="dataReferencia"
              :headers="headersAutorizacao"
              :list="autorizacoes"
              :periodo="periodo"
              :selectItem="(item, action) => selectItem(item, action)"
              :title="'SOLICITAÇÕES DO ' + title"
              />
          </v-col>
          <v-col class="pa-0" cols="12" sm="12" md="12">
              <DashboardList
              :categorias="categoriasTransacao" 
              :date="dataReferencia"
              :headers="headersTransacao"
              :list="transacoes"
              :periodo="periodo"
              :selectItem="(item, action) => selectItem(item, action)"
              :title="'TRANSAÇÕES DO ' + title"
              />
          </v-col>
        </v-row>
    </v-container>

</template>

<script>
import ChartPie from "@/components/autorizador/dashboard_de_monitoramento/GraficoPizza.vue"
import DashboardList from "@/components/autorizador/dashboard_de_monitoramento/List"
export default {
  components: {
    ChartPie,
    DashboardList
  },
  props:{
    dataReferencia: String,
    autorizacoes:  Array,
    transacoes: Array,
    periodo: String,
    setFilter: Function,
    tab: Number,
    title: String,
    visaoDetalhada: Boolean,
  },
  data() {
    return {
      categoriasAutorizacao: [
        {descricao:'Autorizadas', parametro:'autorizadas'},
        {descricao:'Autorizadas \nParcialmente', parametro:'autorizadas_parcialmente'},
        {descricao:'Em análise', parametro:'em_analise'},
        {descricao:'Aguardando dados\ndo prestador', parametro:'aguardando_dados_prestador'},
        {descricao:'Negadas', parametro:'negadas'},
        {descricao:'Canceladas', parametro:'canceladas'},
        {descricao:'Sem resposta', parametro:'sem_resposta'},
        ],
      categoriasTransacao:  [
        {descricao:'Envio\nde Anexos', parametro:'envio_anexos'},
        {descricao:'Solicitação\nde Procedimentos', parametro:'procedimentos'},
        {descricao:'Solicitação de\nstatus de autoriz.', parametro:'status_autoricacao'},
        {descricao:'Verificação de\nElegibilidade', parametro:'elegibilidade'},
        {descricao:'Cancelamento\nde Guia', parametro:'cancelamento_guia'},
        {descricao:'Comunicação\ncom Beneficiário', parametro:'comunicacao_beneficiario'}
        ],
      exibirGraficos: true,
      exibirTabelas:false,
      opts: { periodo: this.periodo },
      selectedItem: {},
      headersAutorizacao: [ 
        { text: "Operadora", align: "Operadora", value: "Operadora", sortable: false },
        { text: "Total", value: "Total", sortable: false },
        { text: "Autorizadas", value: "Autorizadas", sortable: false },
        { text: "Autorizadas parcialmente", value: "AutorizadasParcialmente", sortable: false },
        { text: "Em análise", value: "Analise", sortable: false },
        { text: "Aguardando dados do prestador", value: "prestador", sortable: false },
        { text: "Negadas", value: "Negadas", sortable: false },
        { text: "Canceladas", value: "Canceladas", sortable: false },
        { text: "Sem resposta", value: "SemResposta", sortable: false },
      ],
      headersTransacao: [ 
        { text: "Operadora", align: "Operadora", value: "Operadora", sortable: false },
        { text: "Total", value: "Total", sortable: false },
        { text: 'Envio\nde Anexos', value: "envio_anexos", sortable: false },
        { text: 'Solicitação\nde Procedimentos', value: "procedimentos", sortable: false },
        { text: 'Solicitação de\nstatus de autoriz.', value: "status_autoricacao", sortable: false },
        { text: 'Verificação de\nElegibilidade', value: "elegibilidade", sortable: false },
        { text: 'Cancelamento\nde Guia', value: "cancelamento_guias", sortable: false },
        { text: 'Comunicação\ncom Beneficiário', value: "comunicacao_beneficiario", sortable: false }
      ],
    }
  },
  mounted() {
    if(!this.$store.state.userData.userData.PermissaoAcoes.autorizador.includes('getmonitoramento')) {
      return
    }
  },
  watch:{
    tab(){
      this.exibirGraficos = false
      this.exibirTabelas = false
      setTimeout(()=> {
        this.exibirGraficos = !this.visaoDetalhada
        this.exibirTabelas = this.visaoDetalhada
      }, 30)
    },
    visaoDetalhada(val){
      this.exibirGraficos = false
      this.exibirTabelas = false
      setTimeout(()=> {
        this.exibirGraficos = !val
        this.exibirTabelas = val
      }, 30)
    }
  },
  methods: {
    selectItem(item, action) {
      this.selectedItem = Object.assign({}, item);
      switch (action) {
        case "newDoc":
          this.showList = false;
          break;
      }
    },
    formatDateMonth(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}/${year}`;
    },
    parseDateMonth(date) {
      if (!date) return null;
      const [month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  }
}
</script>

<style>
</style>